/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePatientTreatmentPlanAdverseEffectEntryRequest } from '../models/CreatePatientTreatmentPlanAdverseEffectEntryRequest';
import type { CreatePatientTreatmentPlanAdverseEffectEntryResponse } from '../models/CreatePatientTreatmentPlanAdverseEffectEntryResponse';
import type { GetPatientConsultationListResponse } from '../models/GetPatientConsultationListResponse';
import type { GetPatientConsultationResponse } from '../models/GetPatientConsultationResponse';
import type { GetPatientPregnancyMonitoringListResponse } from '../models/GetPatientPregnancyMonitoringListResponse';
import type { GetPatientPregnancyMonitoringResponse } from '../models/GetPatientPregnancyMonitoringResponse';
import type { GetPatientTreatmentPlanAdverseEffectEntryListResponse } from '../models/GetPatientTreatmentPlanAdverseEffectEntryListResponse';
import type { GetPatientTreatmentPlanAdverseEffectEntryResponse } from '../models/GetPatientTreatmentPlanAdverseEffectEntryResponse';
import type { GetPatientTreatmentPlanLegalEntityResponseItem } from '../models/GetPatientTreatmentPlanLegalEntityResponseItem';
import type { GetPatientTreatmentPlanListResponse } from '../models/GetPatientTreatmentPlanListResponse';
import type { GetPatientTreatmentPlanRecipeListResponse } from '../models/GetPatientTreatmentPlanRecipeListResponse';
import type { GetPatientTreatmentPlanRecipeResponse } from '../models/GetPatientTreatmentPlanRecipeResponse';
import type { GetPatientTreatmentPlanResponse } from '../models/GetPatientTreatmentPlanResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { PregnancyMonitoringSortBy2 } from '../models/PregnancyMonitoringSortBy2';
import type { PregnancyType } from '../models/PregnancyType';
import type { RecipeSortBy2 } from '../models/RecipeSortBy2';
import type { RecipeStatus } from '../models/RecipeStatus';
import type { TreatmentPlanSortBy2 } from '../models/TreatmentPlanSortBy2';
import type { TreatmentPlanStatus } from '../models/TreatmentPlanStatus';
import type { UpdatePatientTreatmentPlanAdverseEffectEntryRequest } from '../models/UpdatePatientTreatmentPlanAdverseEffectEntryRequest';
import type { UpdatePatientTreatmentPlanAdverseEffectEntryResponse } from '../models/UpdatePatientTreatmentPlanAdverseEffectEntryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientTreatmentService {
    /**
     * Gets a list of recipes.
     * Gets a list of recipes for current user as patient.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param treatmentPlanId Filter by treatment plan identifier, optional.
     * @param legalEntityId
     * @param dateIssued Filter by recipe issue date, optional.
     * @param dispensingDate Filter by date the prescribed drugs were dispensed, optional.
     * @param status Filter by recipe status, optional.
     * @param sortBy Sorting by date issued, dispensing date, optional.If no sort option is provided, the list will default to sorted by Created.
     * @param sortDirection Sort direction, default descending.
     * @returns GetPatientTreatmentPlanRecipeListResponse Recipes have been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanRecipeListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        treatmentPlanId?: string | null,
        legalEntityId?: string | null,
        dateIssued?: string | null,
        dispensingDate?: string | null,
        status?: RecipeStatus | null,
        sortBy?: RecipeSortBy2 | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetPatientTreatmentPlanRecipeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/recipes',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'treatmentPlanId': treatmentPlanId,
                'legalEntityId': legalEntityId,
                'dateIssued': dateIssued,
                'dispensingDate': dispensingDate,
                'status': status,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets recipe.
     * Gets recipe for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param recipeId Recipe identifier.
     * @returns GetPatientTreatmentPlanRecipeResponse Recipe has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanRecipeEndpoint(
        id: string,
        recipeId: string,
    ): CancelablePromise<GetPatientTreatmentPlanRecipeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/{id}/recipes/{recipeId}',
            path: {
                'id': id,
                'recipeId': recipeId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/recipe not found.`,
            },
        });
    }
    /**
     * Update adverse effect entries for current authenticated user..
     * Update adverse effect entries in the current treatment plan.
     * @param id Treatment plan identifier.
     * @param adverseEffectEntryId
     * @param requestBody
     * @returns UpdatePatientTreatmentPlanAdverseEffectEntryResponse Adverse effect entries have been updated successfully.
     * @throws ApiError
     */
    public static updatePatientTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        adverseEffectEntryId: string,
        requestBody: UpdatePatientTreatmentPlanAdverseEffectEntryRequest,
    ): CancelablePromise<UpdatePatientTreatmentPlanAdverseEffectEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/patient/treatment-plans/{id}/adverse-effect-entries/{adverseEffectEntryId}',
            path: {
                'id': id,
                'adverseEffectEntryId': adverseEffectEntryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Gets adverse effect entry for current authenticated user.
     * Gets adverse effect entry for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param adverseEffectEntryId Adverse effect entry identifier.
     * @returns GetPatientTreatmentPlanAdverseEffectEntryResponse The adverse effect entry has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        adverseEffectEntryId: string,
    ): CancelablePromise<GetPatientTreatmentPlanAdverseEffectEntryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/{id}/adverse-effect-entries/{adverseEffectEntryId}',
            path: {
                'id': id,
                'adverseEffectEntryId': adverseEffectEntryId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/adverse effect entry not found.`,
            },
        });
    }
    /**
     * Delete adverse effect entry for current authenticated user.
     * Delete adverse effect entry for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param adverseEffectEntryId Adverse effect entry identifier.
     * @returns void
     * @throws ApiError
     */
    public static deletePatientTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        adverseEffectEntryId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/patient/treatment-plans/{id}/adverse-effect-entries/{adverseEffectEntryId}',
            path: {
                'id': id,
                'adverseEffectEntryId': adverseEffectEntryId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/adverse effect entry not found.`,
            },
        });
    }
    /**
     * Gets a list of adverse effect entries for current authenticated user.
     * Gets a list of adverse effect entries in the current treatment plan.
     * @param id Consultation identifier.
     * @returns GetPatientTreatmentPlanAdverseEffectEntryListResponse Adverse effect entries have been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanAdverseEffectEntryListEndpoint(
        id: string,
    ): CancelablePromise<GetPatientTreatmentPlanAdverseEffectEntryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/{id}/adverse-effect-entries',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates adverse effect entries for current authenticated user..
     * Creates adverse effect entries in the current treatment plan.
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns CreatePatientTreatmentPlanAdverseEffectEntryResponse Adverse effect entries have been created successfully.
     * @throws ApiError
     */
    public static createPatientTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        requestBody: CreatePatientTreatmentPlanAdverseEffectEntryRequest,
    ): CancelablePromise<CreatePatientTreatmentPlanAdverseEffectEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/patient/treatment-plans/{id}/adverse-effect-entries',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Gets a list of treatment plans.
     * Gets a list of treatment plans for current authenticated user.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param startDate Search by treatment start date, optional.
     * @param endDate Search by treatment end date, optional.
     * @param treatmentType Search by treatment type, optional. Partial search supported.
     * @param sortBy Sorting by start date, end date and treatment type taking into account Romanian and Russian languages, optional.
     * @param sortDirection Sort direction, default descending.
     * @param legalEntityId Legal entity.
     * @param status
     * @returns GetPatientTreatmentPlanListResponse Treatment plans have been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        startDate?: string | null,
        endDate?: string | null,
        treatmentType?: string | null,
        sortBy?: TreatmentPlanSortBy2 | null,
        sortDirection?: ListSortDirection | null,
        legalEntityId?: string | null,
        status?: TreatmentPlanStatus | null,
    ): CancelablePromise<GetPatientTreatmentPlanListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'startDate': startDate,
                'endDate': endDate,
                'treatmentType': treatmentType,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'legalEntityId': legalEntityId,
                'status': status,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of legal entities belongs to user treatment plans.
     * Gets a list of legal entities belongs to user treatment plans.
     * @returns GetPatientTreatmentPlanLegalEntityResponseItem Treatment plans legal entities have been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanLegalEntityListEndpoint(): CancelablePromise<Array<GetPatientTreatmentPlanLegalEntityResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/legal-entities',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets treatment plan.
     * Gets treatment plan with details for current user.
     * @param id Treatment plan identifier.
     * @returns GetPatientTreatmentPlanResponse The treatment plan has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientTreatmentPlanEndpoint(
        id: string,
    ): CancelablePromise<GetPatientTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/treatment-plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/associated consultations not found.`,
            },
        });
    }
    /**
     * Gets a list of pregnancy monitoring for current user.
     * Gets a list of pregnancy monitoring for current user.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param legalEntityId
     * @param lastMenstrualPeriod Search by last menstrual period, optional.
     * @param gestationalAgeInWeeks Search by gestational age in weeks, optional.
     * @param expectedDateOfBirth Search by expected date of birth, optional.
     * @param pregnancyType Search by pregnancy type identifier, optional.
     * @param sortBy Sorting by created, last menstrual period, gestational age in weeks,  pregnancy type identifier and expected date of birth, optional.
     * @param sortDirection Sort direction, default descending.
     * @returns GetPatientPregnancyMonitoringListResponse Pregnancy monitoring list has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientPregnancyMonitoringListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        legalEntityId?: string | null,
        lastMenstrualPeriod?: string | null,
        gestationalAgeInWeeks?: number | null,
        expectedDateOfBirth?: string | null,
        pregnancyType?: PregnancyType | null,
        sortBy?: PregnancyMonitoringSortBy2 | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetPatientPregnancyMonitoringListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/pregnancy-monitoring',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'legalEntityId': legalEntityId,
                'lastMenstrualPeriod': lastMenstrualPeriod,
                'gestationalAgeInWeeks': gestationalAgeInWeeks,
                'expectedDateOfBirth': expectedDateOfBirth,
                'pregnancyType': pregnancyType,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets pregnancy monitoring for current user.
     * Gets pregnancy monitoring with investigation demands for current user.
     * @param id Pregnancy monitoring identifier.
     * @returns GetPatientPregnancyMonitoringResponse Pregnancy monitoring has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientPregnancyMonitoringEndpoint(
        id: string,
    ): CancelablePromise<GetPatientPregnancyMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/pregnancy-monitoring/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Pregnancy monitoring not found.`,
            },
        });
    }
    /**
     * Gets a list of consultations for current user.
     * Gets a list of consultations for current user.
     * @returns GetPatientConsultationListResponse Consultations have been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientConsultationListEndpoint(): CancelablePromise<GetPatientConsultationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/consultations',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a consultation for current user.
     * Gets a consultation for current user with details.
     * @param id Consultation identifier.
     * @returns GetPatientConsultationResponse The consultation has been retrieved successfully.
     * @throws ApiError
     */
    public static getPatientConsultationEndpoint(
        id: string,
    ): CancelablePromise<GetPatientConsultationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patient/consultations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
}
